import Vue from "vue";
import App from "./App";
import router from "./router";
import "babel-polyfill";
import "lib-flexible/flexible";

import Meta from "vue-meta";
Vue.use(Meta);

import store from "./store";
import animated from "animate.css";
Vue.use(animated);
import $ from "jquery";
// ElementUI
import ElementUI from "element-ui";
import "./assets/theme/index.css";
Vue.use(ElementUI);

// iconfont
import "./assets/iconfont/iconfont.js";
// 公共函数
import {
  parseTime,
  selectDictLabel,
  numberFormat,
  isMobile
} from "./utils/utils";

//公共函数
Vue.prototype.parseTime = parseTime;
Vue.prototype.selectDictLabel = selectDictLabel;
Vue.prototype.numberFormat = numberFormat;
Vue.prototype.isMobile = isMobile;

// Swiper
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";

// import 'swiper/swiper-bundle.css'
Vue.use(VueAwesomeSwiper);

Vue.config.productionTip = false;

// look img
import VueViewer from "v-viewer";
Vue.use(VueViewer);
// 路由拦截守卫
router.beforeEach((to, from, next) => {
  if (to.meta.metaInfo) {
    store.commit("CAHNGE_META_INFO", to.meta.metaInfo);
  }
  next();
});
new Vue({
  router,
  store,
  metaInfo() {
    return {
      title: this.$store.state.metaInfo.title,
      meta: [
        {
          name: "keywords",
          content: this.$store.state.metaInfo.keywords
        },
        {
          name: "description",
          content: this.$store.state.metaInfo.description
        }
      ]
    };
  },
  render: h => h(App)
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js